import React, { Component } from "react";

class Start extends Component {
    render() {
        return (
            <div className="overLay">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-8">
                            <div className="card mt-7">
                                <div className="card-body text-center">
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-md-10 col-xl-8 ">
                                            <img
                                                src="/images/timerModal.png"
                                                alt=""
                                                className="img-fluid mt-n5 mb-4 w-50 m-auto"
                                            ></img>
                                            <p className="text-muted mt-3">
                                                The ProWriter community consists
                                                of only vetted and qualified
                                                writers.Before you gain access
                                                to this community, you’ll need
                                                to complete an English
                                                proficiency test to verify your
                                                qualifications
                                            </p>
                                            <p className="text-muted">
                                                The test will be composed of 3
                                                sections and shouldn’t take more
                                                than 10 minutes to complete.
                                                You’ll be given 2 attempts to
                                                pass the test.
                                            </p>
                                            <p className="text-muted">
                                                <b>NOTE:</b> Do not switch tabs
                                                or open a new window when taking
                                                the test or it will be marked as
                                                invalid.
                                            </p>
                                            <button
                                                onClick={this.props.start}
                                                className="btn btn-primary mt-4"
                                            >
                                                Start
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Start;



// WEBPACK FOOTER //
// ./src/components/writer/quiz/Start.js